import React from 'react'
import { MemberSelectorState } from './state/MemberSelectorState'
import { IMembersSelectorContext } from './MembersSelectors.types'

export const MembersSelectorContext =
  React.createContext<IMembersSelectorContext>(
    null as unknown as IMembersSelectorContext
  )

export const createMemberSelectorContext = (
  args: ConstructorParameters<typeof MemberSelectorState>[0]
) => {
  return new MemberSelectorState(args)
}

export const useMembersSelectorContext = () =>
  React.useContext(MembersSelectorContext)
